import React from 'react';
import styles from './ContentCard.module.scss';
import { useEffect } from "react";
import { useState } from "react";
import { Col, Card, Placeholder } from "react-bootstrap";
import notFoundAH from "images/backgrounds/not_found.png";
import notFoundLib from "images/backgrounds/DefaultCover.svg";
import ApiURLs from "config/ApiURLs";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

export default function ContentCard(props) {
    const { title, blurb, image, id, searchable } = props.data;
    const [recordData, setRedordData] = useState({});
    const [loading, setLoading] = useState({ img: true, data: true });
    const [notFoundImage, setNotFoud] = useState("");
    const [width, setWidth] = useState(null);
    const [height, setHeight] = useState(null);
    useEffect(() => {
        function getImage(element) {
            if (!element?.thumbnail) {
                return notFoundImage;
            }
            if (element.thumbnail === "NULL") {
                return notFoundImage;
            }
            return element.thumbnail;
        }
        function getUrlPath(element, whitDomain = false) {
            /* if (element.contenttype === "page") {
              return ApiURLs.cirmaDomainName + element.id.substring(1);
            }
            if (element.contenttype === "news") {
              return ApiURLs.cirmaDomainName+ "noticia/" + element.id;
            }
            if (element?.repository === "CIRMA-BIB") {
              return whitDomain
                ? ApiURLs.libraryDomainName + "opac/record/" + element.id
                : "opac/record/" + element.id;
            }
            if (element?.contenttype === "library") {
              return whitDomain
                ? ApiURLs.libraryDomainName + "opac/record/" + element.id
                : "opac/record/" + element.id;
            }
            return whitDomain
              ? ApiURLs.cirmaDomainName + "glifos/item/" + element.id
              : "glifos/item/" + element.id; */
            return ApiURLs.tamiDomainName + element.id;
        }
        var temData = props?.data;
        if (Array.isArray(temData?.authors)) {
            temData.authors = temData?.authors[0];
        }
        temData.urlPath = getUrlPath(temData, true);
        temData.thumbnail = getImage(temData, true);

        setRedordData(temData);
        setLoading({ data: false });
        if (props?.data?.contenttype === "item") {
            setNotFoud(notFoundAH);
        } else if (props?.data?.contenttype === "library") {
            setNotFoud(notFoundLib);
        } else {
            setNotFoud(notFoundAH);
        }
    }, [notFoundImage, props?.data]);

    const handleNavigate = (link) => {
        //e.preventDefault();
        /* const encodedSearchText = encodeURIComponent(searchText);
        const absoluteURL = `/search/?keywords=${encodedSearchText}` */;
        if (link) {
            window.location.href = link;
        }
    };

    function proccessImage(image) {
        let imageP = image;
        if (image?.includes("api/glifos/glifos/file/get///default/sites/default/files/styles/large/public") === true) {
            imageP = image.replace("api/glifos/glifos/file/get///default/sites/default/files/styles/large/public", "api/glifos/sites/default/files");
        } else if (image?.includes("api/glifos//default/sites/default/files/styles/large/public") === true) {
            imageP = image.replace("api/glifos//default/sites/default/files/styles/large/public", "api/glifos/sites/default/files");
        } else if (image?.includes("/glifos/glifos/file/get//sites/default/files/") === true) {
            imageP = image.replace("/glifos/glifos/file/get//sites/default/files/", "/glifos/sites/default/files/");
        } else if (image?.includes("/api/v1/file/get//api/v1/website/thumbnail/") === true) {
            imageP = image.replace("/api/v1/file/get//api/v1/website/thumbnail/", "/api/v1/website/thumbnail/");
        } else if (image?.includes("/api/api") === true) {
            imageP = image.replace("/api/api", "/api");
        } else if (image?.includes("//default") === true) {
            imageP = image.replace("//default", "/glifos");
        } 
        return imageP;
    }

    /* const navigate = useNavigate(); */

    return (
        <Col lg={6}>
            {!loading.data && (
                <div className={`${styles.card} link-underline-opacity-0`}>
                    <div className={`${styles.image}`} onClick={() => handleNavigate(id)} style={{ width: width, height: height }}>
                        <LazyLoadImage
                            className="card-img-top cont"
                            src={proccessImage(ApiURLs.ApiUrl + props.data?.thumbnail)} // use normal
                            effect="blur"
                            delayTime={1}
                            onError={({ currentTarget }) => {
                                currentTarget.onerror = null; // prevents looping
                                setHeight("0px");
                                setWidth("0px");
                            }}
                        />
                        {/* <img src={image} alt="content"/> */}
                    </div>
                    <div className={`${styles.title}`}>
                        {title}
                    </div>
                    <div dangerouslySetInnerHTML={{ __html: blurb }} className={`${styles.description}`} />
                    {
                        searchable === 'registered' && (
                            <div className={`${styles.registered}`}>
                                Registered users only
                            </div>
                        )
                    }
                    {/* <div className={`${styles.content}`}>
                        <div className={`${styles.title}`} onClick={()=>handleNavigate(id)}>
                            {title}
                        </div>
                        <div className={`${styles.description}`}>
                            <div dangerouslySetInnerHTML={{ __html: blurb }} />
                        </div>
                        {
                            searchable === 'registered' && (
                                <div className={`${styles.registered}`}>
                                    Registered users only
                                </div>
                            )
                        }

                    </div> */}

                </div>
            )}
        </Col>
    )
}
